// @flow
import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import FiberNewIcon from "@material-ui/icons/FiberNew";
import EditIcon from "@material-ui/icons/Edit";

import ProductSheetPartItem from "../../components/quotes/ProductSheetPartItem";
import { GeneralModalForm } from "imagus-components";
import CreateProductSheetForm from "../../containers/quotes/CreateProductSheetForm";

type ProductSheetItemPropsType = {
  name: string,
  parts: Array<*>,
  canEdit?: boolean,
  productSheet?: { [key: string]: * }
};

type ProductSheetItemStatesType = {
  modalOpen: boolean
};

class ProductSheetItem extends Component<
  ProductSheetItemPropsType,
  ProductSheetItemStatesType
> {
  constructor(props: ProductSheetItemPropsType) {
    super(props);
    this.state = {
      modalOpen: false
    };
  }

  switchModalStatus = (status: boolean): * => {
    this.setState({ modalOpen: status });
  };

  render(): React$Element<*> {
    const title = this.props.productSheet
      ? "Update " + this.props.name
      : "New Price Sheet";
    const IconName = this.props.productSheet ? EditIcon : FiberNewIcon;

    return (
      <Paper className="box-wrapper">
        <Typography variant="h5" className="form-text">
          {this.props.name}
        </Typography>
        <Button
          type="button"
          variant="contained"
          color="primary"
          className="dark-btn"
          style={{ float: "right" }}
          onClick={(): Function => this.switchModalStatus(true)}
        >
          <IconName className="light-icon right-margin-5" />
          {title}
        </Button>
        <GeneralModalForm
          title={title}
          open={this.state.modalOpen}
          handleModalStatus={this.switchModalStatus}
          fullScreen
          form={
            <CreateProductSheetForm
              onClose={(): * => this.switchModalStatus(false)}
              productSheet={this.props.productSheet}
            />
          }
        />
        <Table className="app-table center">
          <TableHead>
            <TableRow>
              <TableCell className="blue-shine">Licence Type</TableCell>
              <TableCell className="blue-shine">Part No.</TableCell>
              <TableCell className="blue-shine">Unit Price</TableCell>
              <TableCell className="blue-shine">Minimun Quantity</TableCell>
              <TableCell className="blue-shine">Maximum Qantity</TableCell>
              <TableCell className="blue-shine">Description</TableCell>
              <TableCell className="blue-shine">Notes</TableCell>
              {this.props.canEdit && (
                <TableCell className="blue-shine">Update</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.parts.map(
              (part: *, i: number): * => {
                return (
                  <ProductSheetPartItem
                    item={part}
                    canEdit={this.props.canEdit}
                    key={i}
                  />
                );
              }
            )}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

export default ProductSheetItem;
